import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const viaSulShoppingTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#00256e',
    },
    secondary: {
      main: '#757575',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#000042',
    },
  },
};
